import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Stack, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconCircleArrowDown } from '@tabler/icons-react';
export const KycMainControl: React.FC = () => {
  const {
    successes
  } = useVerifyAction();
  const isLarge = useMediaQuery('(max-width: 90em)');
  const {
    i18n
  } = useLingui();
  return <>
      {!successes.has(STATUS.ID_VERIFICATION) && <Stack align="center" gap={8} pos="absolute" bottom={isLarge ? '4rem' : '6rem'} left={0} right={0}>
          <Box>
            <Text fz={20} className={gunterzBold.className} c="var(--text-prime)" ta="center">
              {i18n._('COMPLETE ALL STEPS')}
            </Text>
            <Text fz={20} className={gunterzBold.className} c="var(--text-dark)" ta="center">
              {i18n._('TO UNLOCK ARMOR')}
            </Text>
          </Box>
          <Text fz="xs" c="var(--text-prime)" tt="uppercase">
            {i18n._('(1.3x multiplier)')}
          </Text>
          <ActionIcon variant="transparent">
            <IconCircleArrowDown size={48} color="var(--text-prime)" />
          </ActionIcon>
        </Stack>}
    </>;
};